<template>
  <div class="header-top">
    <img :src="logo_image" alt="" />
  </div>
</template>

//
<script>
// import { mapState } from "vuex";
// import { browserRedirect, calcul } from "../utils";
export default {
  data: () => ({
    logo_image: "",
  }),
  mounted() {
    this.logo_image = this.$store.state.defaultSetting.logo_image;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.header-top {
  width: 100%;
  // height: 10vh;
  background: #ffffff;
  padding: 5px 26px;
  text-align: left;
}
</style>
